import { render, staticRenderFns } from "./markAsReadButton.vue?vue&type=template&id=7e68cb74"
import script from "./markAsReadButton.vue?vue&type=script&lang=js"
export * from "./markAsReadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports